import React from 'react'
import { ReactComponent as CustomSoftwareSvg} from '../../assets/svgs/Custum_Sofware.svg';

const CustomSoftwareIcon = () => (
    <div>
        <CustomSoftwareSvg/>
    </div>
)

export default CustomSoftwareIcon